module.exports = __webpack_public_path__ + "static/media/coupon.5f6aed9c.svg";